import React from "react";
import { FormConfiguration } from "../FormConfiguration";
import { FormRuntime } from "../FormRuntime";
import { TextFormControl } from "../Controls/Web/TextFormControl";
import { XStackContainer } from "./XStackContainer";
import { BorderStyle } from "../Utilities/FormDesignConstants";
import { DefaultOnOff } from "../Utilities/DefaultOnOff";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration; container: XStackContainer } {
    let ui = new FormConfiguration();
    let stackContainer = new XStackContainer();
    // show border so we can see
    stackContainer.overrideFormBorderSettings = DefaultOnOff.On;

    stackContainer.add(new TextFormControl());
    stackContainer.add(new TextFormControl());
    stackContainer.add(new TextFormControl());
    ui.add(stackContainer);

    return { form: ui, container: stackContainer };
}

export const ContainerStackStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Stack Container",
        "Control Stack"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.containerBorderColor = "red";
            ui.container.containerBorderRadius = 50;
            ui.container.containerBorderStyle = BorderStyle.Dashed;
            ui.container.containerBorderWidth = 10;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Stack Container",
        "Override Border"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.containerBackgroundColor = "blue";
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Stack Container",
        "Override Color"
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            ui.container.interControlSpacing = 30;
            ui.container.innerMargin = 30;
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Stack Container",
        "Override Spacing"
    ),

    new StoryNode(
        () => {
            let form = new FormConfiguration();
            form.defaultShowContainerBorder = true;

            return <FormRuntime form={form}></FormRuntime>;
        },

        "Form Builder",
        "Containers",
        "Stack Container",
        "Placeholder In Runtime"
    ),
];
